import { useEffect, useState } from "react";
import { useContext } from 'react';
import { getLocations, getLabConfig } from "../../utils/api";
import LabIDContext from '../../store/LabIDContext';

const DrawLocation_ScheduleHub = ({ orderInfo }) => {

	const [locations, setLocations] = useState([]);
	const LabID = useContext(LabIDContext);
	const token = sessionStorage.getItem('token');
	console.log(orderInfo);
	useEffect(() => {
	  (async () => {
		const location = await getLocations(LabID);
		const cleaned = (location ?? []).map((o) => ({
		  ...o,
		  OrgName: o.OrgName == null ? null : String(o.OrgName).trim(),
		  OrgCode: String((o.OrgCode ?? o.OrgName ?? "")).trim(),
		  OrgAdd: String(o.OrgAddress1 ?? "").trim(),
		  OrgCity: String(o.OrgCity ?? "").trim(),
		  OrgState: String(o.OrgState ?? "").trim(),
		  OrgZip: String(o.OrgZip ?? "").trim(),
		  OrgDetails: String(o.Details ?? "").trim(),
		}));
		setLocations(cleaned);
	  })();
	}, []);
	const [PPURL, setPPURL] = useState([]);
		useEffect(() => {
			async function fetchPortalTitle() {
				let PPURL2="http://localhost:3001";
				if (process.env.NODE_ENV === 'production') {
					 PPURL2 = await getLabConfig("PPWEBSERVER");
				}
				console.log(PPURL2);
				setPPURL(PPURL2);
			}
			fetchPortalTitle();
		}, []);
	let ScheduleHUBURL=PPURL;
		if(!PPURL.includes("localhost")) {
			ScheduleHUBURL = PPURL + '/' + LabID + '/scheduleHub' 
		}
  return (
		<tbody>
			 <>
				<a
				  href={`${ScheduleHUBURL}?reqnumber=${orderInfo.reqnum}&displayReqNum=${orderInfo.reqinfo[orderInfo.reqnum].disReqNum}&token=${token}`}
				  target="_scheduleHub"
				  title="Scheduler"
				  rel="noopener noreferrer"
				>
				Schedule your Lab Visit
				</a>
			</>
		  {locations.map((r, idx) => (
			<tr key={idx}>
			  <td>{r.OrgName}
			  <br/>
				{r.OrgAdd}
				<br />
				{r.OrgCity}, {r.OrgState}  {r.OrgZip}
			  <br/>
			  <br/>{r.OrgDetails}</td>
			</tr>
				  ))}
		</tbody>
    );

};

export default DrawLocation_ScheduleHub;
